import React from "react";
import { map, isEmpty, filter, size } from "lodash";
import FontIcon from "react-md/lib/FontIcons";
import Avatar from "react-md/lib/Avatars";
import { countryNameFromCountryCode } from "../../Atollon/CountryCodes"

import {DebugElement} from "../../Atollon/debug";
import {array_utilities} from "../../Atollon/utilities/array_utilities";
import {TouchAvatar, TouchTable} from "../../AtollonTheme/ReactElements";

const userAvatar = <Avatar icon={<FontIcon>person</FontIcon>} suffix="black" />;

const ContactsTable = ({
  history,
  array
}) => {

    let drawPersonOrOrganization = ( item, i ) =>
    {

        let avatar = (
            <TouchAvatar
                image={""}
                text={item.name || ""}
                subtext={<span className={"link"}>{item.identifier}</span>}
                onClick={() => history.push(`/person/${item.identifier}`)}
            />
        );

        if( item.type === "ORGANIZATION" )
        {
            let address;
            if( item.address )
            {
                address = (
                    <div>
                        <div>{
                            array_utilities.array_join_with_string([item.address.address1, item.address.address2, item.address.city], ",", true )
                        }</div>
                        <div>{
                            countryNameFromCountryCode( item.address.countryCode )
                        }</div>
                    </div>
                );
            }
            else
            {
                address = (<div />);
            }

            return [ avatar, address ];
        }
        else
        {
            let address = (<div />);

            return [ avatar, address ];
        }
    };

    const shouldDrawAnyArray = size( array ) > 0;
    const reactArray = map( array, (item, i) => drawPersonOrOrganization( item ) );

    return (
            <div className="requests-table">
                <DebugElement text={"src/components/contacts/ContactsTable.js"}/>

                {shouldDrawAnyArray ? (
                    <TouchTable
                        headerAsList={["Jméno","Adresa"]}
                        elementsAsList={reactArray}
                    />
                ) : (
                    <p>V seznamu nejsou žádné kontakty.</p>
                )}
            </div>
        );
};

export default ContactsTable;



// WEBPACK FOOTER //
// ./src/components/contacts/ContactsTable.js